<section id="contact" class="contact section">
    <div class="container section-title" data-aos="fade-up">
        <h2>Contact <span>Us</span></h2>
        <p>Have questions or feedback? We'd love to hear from you!</p>
    </div>

    <div class="container" data-aos="fade-up" data-aos-delay="100">
        <div class="row gy-4 mt-1">
            <div class="col-lg-3" data-aos="fade-up" data-aos-delay="300">
                <div class="mb-4">
                    <div class="info-item d-flex flex-column justify-content-center align-items-center"
                        data-aos="fade-up" data-aos-delay="300">
                        <i class="bi bi-telephone"></i>
                        <h3>Call Us</h3>
                        <a href="tel:6476763338">+1(647)676-3338</a>
                    </div>
                </div>
                <div>
                    <div class="info-item d-flex flex-column justify-content-center align-items-center"
                        data-aos="fade-up" data-aos-delay="400">
                        <i class="bi bi-envelope"></i>
                        <h3>Email Us</h3>
                        <a href="mailto: allinoneinvoice@outlook.com">allinoneinvoice&#64;outlook.com</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="300">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d92718.26524949967!2d-80.55871520769858!3d43.43040476845004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882bf48c03ee5105%3A0x9525f8e6df5f544b!2sKitchener%2C%20ON!5e0!3m2!1sen!2sca!4v1718433123151!5m2!1sen!2sca"
                    frameborder="0" style="border:0; width: 100%; height: 400px;" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>

            <div class="col-lg-5">
                <kt-app-contact-form/>
            </div>
        </div>
    </div>
</section>